// extracted by mini-css-extract-plugin
module.exports = {"overlay":"CaptchaOverlay_overlay__2-9C_","captcha":"CaptchaOverlay_captcha__dx7l8"};